
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1599016452086",
    "class": "icon",
    "viewBox": "0 0 1147 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "9426",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "560.05859375",
    "height": "500"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M1038.020219 178.928351 106.89802 178.928351 10.24 431.8492C10.24 507.56499 73.069837 570.38696 150.394994 570.38696 227.71386 570.38696 292.153063 509.174358 292.153063 431.8492 292.153063 507.56499 354.9829 570.38696 432.308058 570.38696 509.633217 570.38696 574.066127 509.174358 574.066127 431.8492 574.066127 507.56499 636.895965 570.38696 714.221122 570.38696 791.547853 570.38696 854.369823 509.174358 854.369823 431.8492 854.369823 507.56499 917.199661 570.38696 996.135758 570.38696 1073.460916 570.38696 1137.90012 509.174358 1137.90012 431.8492L1038.020219 178.928351 1038.020219 178.928351ZM960.69506 613.883935 960.69506 936.073665 187.445059 936.073665 187.445059 613.883935 106.89802 613.883935 106.89802 952.186218C106.89802 981.180006 139.118409 1016.619131 168.112197 1016.619131L978.418557 1016.619131C1007.410772 1016.619131 1039.631159 981.180006 1039.631159 952.186218L1039.631159 613.883935 960.69506 613.883935 960.69506 613.883935ZM1038.020219 177.318984 1038.020219 177.318984 1041.240527 180.134984 1038.020219 177.318984 1038.020219 177.318984ZM171.330932 114.495439 976.801323 114.495439C1004.192035 114.495439 1025.134266 93.553209 1025.134266 66.16407 1025.134266 38.779649 1004.192035 17.837419 976.801323 17.837419L171.330932 17.837419C143.948085 17.837419 123.005855 38.779649 123.005855 66.16407 123.005855 93.553209 143.948085 114.495439 171.330932 114.495439L171.330932 114.495439Z",
        "p-id": "9427"
      }
    }
  ]
})
    }
  